<template>
  <v-dialog persistent v-model="rejectModal" width="500">
    <v-card>
      <v-card-title class="headline red lighten-1 white--text" default-title>Reject Visa Request</v-card-title>

      <v-card-text class="pa-0">
        <v-container grid-list-md>
          <v-layout wrap>
            <form-error-display-handler :errors="errors"></form-error-display-handler>
            <v-flex xs12>
              <v-form ref="rejectForm" v-model="valid" lazy-validation class="px-2">
                <v-textarea
                    label="Remarks *"
                    :rules="[rules.required]"
                    outlined
                    v-model="rejectForm.remarks"
                ></v-textarea>
                <multiple-file-upload
                    label="Upload documents"
                    v-model="rejectForm.files"
                    :required="false"
                ></multiple-file-upload>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="red lighten-1"
            :loading="loading"
            class="white--text"
            @click="closeModal"
        >Cancel
        </v-btn>
        <v-btn color="blue darken-3" :loading="loading" class="white--text" @click="reject">Reject</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.section-header {
  font-size: 1.5em;
  font-weight: 400;
}

</style>
<script>
import {mapActions} from "vuex";
import {validationMixin} from "../../mixins/validationMixin";
import FormErrorDisplayHandler from "../FormErrorDisplayHandler";
import FileInput from "../FileInput";
import MultipleFileUpload from "../MultipleFileUpload";

export default {
  data: () => ({
    valid: true,
    rejectForm: {},
    errors: [],
    loading: false
  }),
  components: {
    FormErrorDisplayHandler,
    FileInput,
    MultipleFileUpload
  },
  mixins: [validationMixin],
  computed: {
    rejectModal: {
      get() {
        return this.$store.state.VisaRequestSingle.rejectModal;
      },
      set(value) {
        this.$store.commit("VisaRequestSingle/setRejectModal", value);
      }
    },
  },
  methods: {
    ...mapActions("VisaRequestSingle", ["rejectRequest"]),
    reject() {
      if (this.$refs.rejectForm.validate()) {
        this.loading = true;
        let formData = new FormData();
        formData.set('remarks', this.rejectForm.remarks);
        let files = this.rejectForm.files;
        if (files !== undefined) {
          formData.set('file', this.rejectForm.file);
          for (let i = 0; i < files.length; i++) {
            formData.append(`files[${i}]`, files[i]);
          }
        }
        this.rejectRequest(formData)
            .then(res => {
              this.form = false;
              this.approveForm = {};
              this.errors = null;
              this.rejectModal = false;
              this.loading = false;
              this.$store.commit("Notification/showSuccess", 'Visa rejected !!');
            })
            .catch(error => {

              this.loading = false;
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
              }
            });
      } else {
        this.$store.commit("Notification/showError", "Invalid Form Data");
      }
    },
    closeModal() {
      this.rejectModal = false;
      this.rejectForm = false
    }
  }
};
</script>
